import React from "react";
import { Box, Button, useMediaQuery } from "@mui/material";
import theme from "../../theme";
import { isDeviceTypeMobile } from "../../utils/helpers";

// --- Interfaces ---
export interface TabItem {
  id: string;
  label: string;
  icon: React.ElementType<any> | string;
  iconType?: "svg" | "mui" | "img";
  iconContent?: React.ReactNode; // For SVG path/content
}
interface CustomTabBarProps {
  tabs: TabItem[];
  activeTabId: string;
  pageTypeSummary?:string;
  onTabChange: (tabId: string) => void;
}

const CustomTabBar: React.FC<CustomTabBarProps> = ({
  tabs,
  activeTabId,
  pageTypeSummary,
  onTabChange,
}) => {
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const deviceType = sessionStorage.getItem("deviceType");
  return pageTypeSummary!=="loansummary"?
      (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            overflowX: "auto",
            bgcolor: "#f5f7fa",
            py: 1,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            mt: isDeviceTypeMobile(isXsOrSm) ? 10 : 0
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
              // Apply the responsive padding to the content wrapper
              pr: { xs: 5, sm: 5, md: 0 },
            }}
          >
            {tabs.map((tab) => (
              <Button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                sx={{
                  textTransform: "none",
                  borderRadius: "20px",
                  px: 2,
                  py: 1,
                  flexShrink: 0,
                  minWidth: "auto",
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  bgcolor: activeTabId === tab.id ? "#e0f7fa" : "#ffffff",
                  color: activeTabId === tab.id ? "#00b3b5" : "#616161",
                  border:
                    activeTabId === tab.id
                      ? "1px solid #00b3b5"
                      : "1px solid #e0e0e0",
                  boxShadow:
                    activeTabId === tab.id
                      ? "0px 2px 4px rgba(0, 0, 0, 0.1)"
                      : "none",
                  "&:hover": {
                    bgcolor: activeTabId === tab.id ? "#d4f0f0" : "#f5f5f5",
                    borderColor: activeTabId === tab.id ? "#00999a" : "#c0c0c0",
                  },
                  "& .MuiButton-startIcon": {
                    color: activeTabId === tab.id ? "#00b3b5" : "#9e9e9e",
                    fontSize: "1rem",
                  },
                }}
                startIcon={
                  tab.iconType === "svg" ? (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          color: activeTabId === tab.id ? "#00b3b5" : "#9e9e9e",
                        }}
                      >
                        {/* You can replace below with tab.iconContent or import SVG as ReactComponent */}
                        {tab.iconContent}
                      </svg>
                    </span>
                  ) : typeof tab.icon === "string" ? (
                    <img
                      src={tab.icon}
                      alt={tab.label}
                      style={{ height: "1.2em" }}
                    />
                  ) : (
                    <tab.icon
                      sx={{
                        fontSize: "1rem",
                        color: activeTabId === tab.id ? "#00b3b5" : "#9e9e9e",
                      }}
                    />
                  )
                }
              >
                {tab.label}
              </Button>
            ))}
          </Box>
        </Box>
      )
      :
      (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            overflowX: "auto",
            bgcolor: "#f5f7fa",
            py: 1,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            mt: isDeviceTypeMobile(isXsOrSm) ? 10 : 0
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
              // Apply the responsive padding to the content wrapper
              pr: { xs: 5, sm: 5, md: 0 },
            }}
          >
            <b>
              Loan Application Overview
            </b>
          </Box>
        </Box>
      )
};

export default CustomTabBar;
